import { render } from "./DistributorServiceProductDialog.vue?vue&type=template&id=346016f0"
import script from "./DistributorServiceProductDialog.vue?vue&type=script&lang=js"
export * from "./DistributorServiceProductDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__